import { TranslationKey } from './types';

export default {
	DEFERRED_PAYMENT_BANNER_1:
		'Fizessen kényelmesen csak a\u00A0termék kézbesítése és kipróbálása után. Ingyenesen és\u00A0felár nélkül.',
	DEFERRED_PAYMENT_BANNER_2: 'Ma 0\u00A0Ft, a fennmaradó rész 30\u00A0nap múlva.',
	PAY_IN_THREE_BANNER_1:
		'Ossza fel a fizetést 3\u00A0harmadra. Az elsőt azonnal fizeti, a fennmaradó kettőt 30\u00A0, illetve 60\u00A0nap múlva. Ingyenesen és\u00A0felár nélkül.',
	PAY_IN_THREE_BANNER_WITH_AMOUNT:
		'Fizesse ki 3\u00A0részletben, {amount} összegben. Ingyenesen és\u00A0felár nélkül.',
	MORE_INFO: 'Hogy működik?',
	DEFERRED_PAYMENT_MODAL_TITLE: 'Vásároljon most, fizessen 30\u00A0nap múlva',
	DEFERRED_PAYMENT_MODAL_SUB_TITLE: 'Ingyenesen és\u00A0felár nélkül.',
	DEFERRED_PAYMENT_MODAL_STEP_1: 'Helyezze a terméket a\u00A0kosárba.',
	DEFERRED_PAYMENT_MODAL_STEP_2:
		'A felkínált \u00A0fizetési módok közül válassza a\u00A0Skip\u00A0Pay Halasztott Fizetését.',
	DEFERRED_PAYMENT_MODAL_STEP_3:
		'Kész. A megvásárolt terméket csak azután fizeti ki, hogy otthon nyugodtan kipróbálta. Erre akár 30\u00A0napja van.',
	MODAL_MORE_INFO: 'További\u00A0információk',
	PAY_IN_THREE_MODAL_TITLE: 'Ossza fel a vásárlás összegét \u00A0harmadokra',
	PAY_IN_THREE_MODAL_SUB_TITLE: 'Ingyenesen és\u00A0felár nélkül.',
	PAY_IN_THREE_MODAL_STEP_1:
		'A\u00A0kosárban a fizetési módok közül válassza a\u00A0Skip\u00A0Pay 3\u00A0Vásárlás Három Részletben opciót.',
	PAY_IN_THREE_MODAL_STEP_1_DYNAMIC:
		'A\u00A0kosárban fizetési módként válassza a Skip Pay \u00A0od\u00A0Vásárlás Három Részletben opciót.',
	PAY_IN_THREE_MODAL_STEP_2: 'A vásárlás árának első harmadát \u00A0bankkártyával fizesse ki.',
	PAY_IN_THREE_MODAL_STEP_3:
		'Kész. A fennmaradó két harmadot \u00A030 és\u00A060\u00A0nap múlva fizeti ki.',
	PAY_IN_THREE_MODAL_PAY_TODAY: 'Ma fizet',
	PAY_IN_THREE_UNTIL: 'eddig',
	CLOSE_MODAL: 'Bezár',
} as Record<TranslationKey, string>;
